import 'script-loader!jquery';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js';
import 'script-loader!smartmenus';
import 'hamburgers/dist/hamburgers.css';
import AOS from 'aos';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '@fortawesome/fontawesome-free/css/all.css';
import 'smartmenus/dist/css/sm-core-css.css';
import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import '../scss/entry.scss';

jQuery(document).ready(function($) {
	
	// tab content block
	$('.ffw-tabber').on('click', function() {
		$(this).siblings().removeClass('active');
	});

	// simple accordion
	$('.simple-accordion-toggle').on('click', function(e) {
		$(this).toggleClass('accordion-active');
		$(this).siblings('.simple-accordion-content').slideToggle('fast');
	})

	// text accordions
	$('.text-accordion-toggle').on('click', function(e) {
		$(this).toggleClass('accordion-active');
		$(this).siblings('.text-accordion-content').slideToggle('fast');
	})

	// full width image slider
	const allFullWidthImageLinks = Array.from(document.querySelectorAll('.fwil__ilp--container.swiper'));

	if (allFullWidthImageLinks.length > 0) {
		allFullWidthImageLinks.forEach(fwi => {
			let closestFWIcontainer = fwi.closest(".fwil__container");
			let fwiPrev = closestFWIcontainer.querySelector(".fwil__ilp--btn-prev");
			let fwiNext = closestFWIcontainer.querySelector(".fwil__ilp--btn-next");

			if (fwi.classList.contains('autoplay-on')) {
				let autoplaySpeed = parseInt(fwi.dataset.autoplaySpeed);
				let fwiSwiper = new Swiper(fwi, {
					modules: [Navigation, Autoplay],
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
					navigation: {
						nextEl: fwiNext,
						prevEl: fwiPrev
					},
					autoplay: {
						disableOnInteraction: true,
						delay: autoplaySpeed
					}
				})
			} else {
				let fwiSwiper = new Swiper(fwi, {
					modules: [Navigation],
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
					navigation: {
						nextEl: fwiNext,
						prevEl: fwiPrev
					}
				})
			}
		})
	}

	// Graduate Logos Slider
	const graduateLogosSwiper = document.querySelector(".graduate-logos__logos--wrapper");

	if (graduateLogosSwiper) {
		const graduateTimeToShow = parseInt(graduateLogosSwiper.dataset.timeToShow);
		const graduateTimeToScroll = parseInt(graduateLogosSwiper.dataset.timeToScroll);
		const graduateSwiper = new Swiper(graduateLogosSwiper, {
			modules: [Autoplay],
			slidesPerView: 2,
			spaceBetween: 30,
			loop: true,
			speed: graduateTimeToScroll,
			autoplay: {
				disableOnInteraction: true,
				delay: graduateTimeToShow
			},
			breakpoints: {
				767: {
					slidesPerView: 4,
					spaceBetween: 50
				},
				450: {
					slidesPerView: 3,
					spaceBetween: 40
				}
			}
		})
	}

	// Fifty Fifty Tabbed Content
	const fftcContainers = Array.from(document.querySelectorAll('.fftc__container'));

	if (fftcContainers.length > 0) {
		fftcContainers.forEach(container => {
			const allFFTCButtons = Array.from(container.querySelectorAll('.fftc__tab--toggle'));

			allFFTCButtons.forEach(button => {
				button.addEventListener("click", (e) => {
					if (button.classList.contains('active-tab')) {
						return;
					} else {
						const currentActiveTab = container.querySelector('.active-tab');
						const currentActiveTabID = currentActiveTab.dataset.tabId;
						const currentActiveTabContent = container.querySelector(`[data-tab-content-id='${currentActiveTabID}']`);
						const newActiveTabID = button.dataset.tabId;
						const newActiveTabContent = container.querySelector(`[data-tab-content-id='${newActiveTabID}']`);
						currentActiveTab.classList.remove('active-tab');
						currentActiveTabContent.classList.remove('active-content');
						button.classList.add('active-tab');
						newActiveTabContent.classList.add('active-content');
					}
				})
			})
		})
	}

	// Image Carousel Swiper
	const allImageCarousels = Array.from(document.querySelectorAll('.image-carousel__images--wrapper'));

	if (allImageCarousels.length > 0) {
		allImageCarousels.forEach(carousel => {
			let scrollSpeed = parseInt(carousel.dataset.scrollSpeed);
			let carouselSwiper = new Swiper(carousel, {
				modules: [Autoplay],
				slidesPerView: 2,
				spaceBetween: 10,
				loop: true,
				speed: scrollSpeed,
				autoplay: {
					delay: 0,
					disableOnInteraction: true
				},
				breakpoints: {
					450: {
						slidesPerView: 3
					},
					991: {
						slidesPerView: 4
					}
				}
			})
		})
	}

	// Student Reviews Read More
	const allReadMores = Array.from(document.querySelectorAll(".student-reviews__review--read-more"));

	if (allReadMores.length > 0) {
		allReadMores.forEach(link => {
			link.addEventListener("click", (e) => {
				const linkContainer = link.closest(".student-reviews__review--container");
				const currentExcerpt = linkContainer.querySelector(".has-more");
				const currentHidden = linkContainer.querySelector(".more-hidden");
				currentExcerpt.style.display = "none";
				currentHidden.style.display = "block";
			})
		})
	}

	// Scheduling tabs
	const schedulingContainer = document.querySelector(".scheduling__container");

	if (schedulingContainer) {
		const schedulingTabs = document.querySelector(".scheduling__tabs--container");

		if (schedulingTabs) {
			const allSchedulingTabs = Array.from(document.querySelectorAll('.scheduling__tab'));

			if (allSchedulingTabs.length > 1) {
				allSchedulingTabs.forEach(tab => {
					tab.addEventListener("click", (e) => {
						if (tab.classList.contains("active-tab")) {
							return;
						}

						const oldActiveTab = schedulingContainer.querySelector(".active-tab");
						const oldActiveSchedule = schedulingContainer.querySelector(".active-schedule");
						const thisTab = tab.dataset.schedule;
						const newSchedule = schedulingContainer.querySelector(`[data-schedule-id='${thisTab}']`);

						if (newSchedule) {
							oldActiveTab.classList.remove('active-tab');
							oldActiveSchedule.classList.remove('active-schedule');
							tab.classList.add('active-tab');
							newSchedule.classList.add('active-schedule');
						}
					})
				})

			}
		}
	}

	// Alumni Spotlight Swiper
	const alumniSpotlightSwiperContainer = document.querySelector(".alumni-spotlight__cards--wrapper");

	if (alumniSpotlightSwiperContainer) {
		const alumniSpotlightPrev = document.querySelector(".alumni-spotlight__cards--buttons-prev");
		const alumniSpotlightNext = document.querySelector(".alumni-spotlight__cards--buttons-next");
		const alumniSwiper = new Swiper(alumniSpotlightSwiperContainer, {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			navigation: {
				prevEl: alumniSpotlightPrev,
				nextEl: alumniSpotlightNext
			},
			breakpoints: {
				600: {
					slidesPerView: 2,
				},
				867: {
					slidesPerView: 3
				}
			}
		})
	}

	// Utility nav dropdowns
	const utilityNavToggles = Array.from(document.querySelectorAll('.utility-nav-link-toggle'));

	if (utilityNavToggles.length > 0) {
		const closeUtilityDropdowns = (except) => {
			utilityNavToggles.forEach(otherToggle => {
				if (otherToggle === except) {
					return;
				}

				const otherParent = otherToggle.closest('.utility-nav-link');

				if (otherParent) {
					otherParent.classList.remove('is-open');
				}

				otherToggle.setAttribute('aria-expanded', 'false');
			})
		}

		utilityNavToggles.forEach(toggle => {
			toggle.addEventListener("click", (e) => {
				e.preventDefault();
				e.stopPropagation();

				const parent = toggle.closest('.utility-nav-link');

				if (!parent) {
					return;
				}

				const willOpen = !parent.classList.contains('is-open');
				closeUtilityDropdowns(toggle);
				parent.classList.toggle('is-open', willOpen);
				toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
			})
		})

		document.addEventListener("click", (e) => {
			if (!e.target.closest('.utility-nav-link.has-sub-links')) {
				closeUtilityDropdowns(null);
			}
		})

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				closeUtilityDropdowns(null);
			}
		})
	}

	// desktop header search toggle
	$('li.dt-search a').on('click', function() {
		$(this).children().toggleClass('fa-search fa-times');
		$('.dt-search-wrap').toggleClass('open closed');
		$('.utility-menu > .menu-item').each(function(i) {
			$(this).toggleClass('menu-item-hidden');
		})
	});

	// FAQs accordions
	$(".faqs__faq--toggle").on("click", function(e) {
		$(this).toggleClass('faq-active');
		$(this).siblings('.faqs__faq--content').slideToggle('fast');
	})

	// headline text
	$(".hat__accordion--toggle").on("click", function(e) {
		$(this).toggleClass('active-accordion');
		$(this).parent().parent().siblings(".hat__lower").find(".hat__accordion--content").slideToggle("fast");
	})

	// bootstrap popovers -- see: https://getbootstrap.com/docs/5.0/components/popovers/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="popover"]')[0]) {
			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl)
			});
			// dismiss the popover on click
			var popover = new bootstrap.Popover(document.querySelector('.popover-dismiss'), {
				trigger: 'focus'
			});
		}
	});

	// bootstrap tooltips -- see: https://getbootstrap.com/docs/5.0/components/tooltips/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="tooltip"]')[0]) {
			var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
			var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new bootstrap.Tooltip(tooltipTriggerEl)
			});
		}
	});

	// hamburger stuffs
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
			}, false);
		});
	}

	// acf accordions
	$('.acf-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.icon').children('.plus-minus').toggleClass('plusser minus');
	});

	// accordions
	$('.accordion-toggle').on('click', function() {
		$(this).next('.accordion-toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
		$(this).toggleClass('active');
	});

	// simple accordions
	$('.simple-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
	});

	// header search toggle
	$('#search-toggle').on('click', function() {
		$(this).toggleClass('glass').toggleClass('close');
		$('#search-box').toggleClass('open');
		$('#top-search').focus();
	});

	// add responsive class to all images
	$(function() {
		$('img').addClass('img-fluid');
	});

	// primary menu
	$(function() {
		$('.sm').smartmenus({
			subMenusSubOffsetX: 0,
			subMenusSubOffsetY: -1
		});
	});

	// primary navigation toggle
	$('.nav-toggle').on('click', function() {
		$('.primary-nav-wrap').slideToggle('fast');
	});

	// scroll back to top button
	$(document).ready(function($){
		// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = 1200,
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 300,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');
		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		//smooth scroll to top
		$back_to_top.on('click', function(event){
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
				}, scroll_top_duration
			);
		});
	});

	// header scroll effects
	(function () {
		var previousScroll = 0;
		$(window).scroll(function(){
			var scrollTop = $(window).scrollTop();
			var currentScroll = $(this).scrollTop();
			if (currentScroll > previousScroll) {
				$('#masthead').addClass('scrolling-down');
				$('#masthead').removeClass('scrolling-up');
			} else {
				$('#masthead').addClass('scrolling-up');
				
				$('#masthead').removeClass('scrolling-down');
			}
			if (scrollTop == 0) {
				$('#masthead').removeClass('scrolling-up');
			}
			previousScroll = currentScroll;
		});
	}());

	// fancybox
	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});

	// Home Hero Volume Buttons
	const homeHeroButtonDesktop = document.querySelector(".home-hero__video--control");

	if (homeHeroButtonDesktop) {
		const homeHeroVideo = document.querySelector(".home-hero__video--container .home-hero__video");

		homeHeroButtonDesktop.addEventListener("click", (e) => {
			if (e.target.classList.contains("unmuted")) {
				e.target.classList.remove("unmuted");
				homeHeroVideo.muted = true;
			} else {
				e.target.classList.add("unmuted");
				homeHeroVideo.muted = false;
			}
		})
	}

	// animate on scroll init
	const throttle = (func, delay) => {
		let prev = 0;
		return (...args) => {
			let now = new Date().getTime();

			if (now - prev > delay) {
				console.log('hit')
				prev = now;
				return func(...args);
			}
		}
	}

	// ios/macOS check
	const tableRowHeads = Array.from(document.querySelectorAll('.program-schedules__table--row-head'));

	if (tableRowHeads.length > 0) {
		const userAgent = window.navigator.userAgent.toLowerCase();
		const isMac = /macintosh|mac os x/i.test(userAgent);
		const isIOS = /iphone|ipad|ipod/i.test(userAgent);
	
		// Additional check for iPads that identify as Mac
		const isIPad = (/iPad|Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
	
		if (isMac || isIOS || isIPad) {
			tableRowHeads.forEach(head => head.classList.add("mac-support"));
		}

	}

});
